export default __webpack_public_path__ + "static/media/logo-white.f975b746.svg";